<script>
import { mapGetters } from 'vuex';
import { useTrack } from 'dashboard/composables';
import TableFooter from 'dashboard/components/widgets/TableFooter.vue';

import NotificationTable from './NotificationTable.vue';

import { ACCOUNT_EVENTS } from '../../../../helper/AnalyticsHelper/events';
export default {
  components: {
    NotificationTable,
    TableFooter,
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      meta: 'notifications/getMeta',
      records: 'notifications/getNotifications',
      uiFlags: 'notifications/getUIFlags',
    }),
  },
  mounted() {
    this.$store.dispatch('notifications/get', { page: 1 });
  },
  methods: {
    onPageChange(page) {
      window.history.pushState({}, null, `${this.$route.path}?page=${page}`);
      this.$store.dispatch('notifications/get', { page });
    },
    refreshNotifications() {
      this.$store.dispatch('notifications/get', {
        page: Number(this.meta.currentPage) || 1,
      });
    },
    markNotificationRead(notification) {
      const {
        primary_actor_id: primaryActorId,
        primary_actor_type: primaryActorType,
      } = notification;
      this.$store.dispatch('notifications/read', {
        id: notification.id,
        primaryActorId,
        primaryActorType,
        unreadCount: this.meta.unreadCount,
      });
    },
    openNotification(notification) {
      const {
        primary_actor: primaryActor,
        notification_type: notificationType,
      } = notification;

      useTrack(ACCOUNT_EVENTS.OPEN_CONVERSATION_VIA_NOTIFICATION, {
        notificationType,
      });
      this.markNotificationRead(notification);

      if (notificationType === 'system_alert') {
        const detailsUrl = primaryActor?.actions?.details_url;
        if (detailsUrl)
          window.open(detailsUrl, '_blank', 'noopener,noreferrer');
        return;
      }

      this.$router.push(
        `/app/accounts/${this.accountId}/conversations/${primaryActor.id}`
      );
    },
    openRelatedConversation(notification, displayId) {
      this.markNotificationRead(notification);
      this.$router.push(
        `/app/accounts/${this.accountId}/conversations/${displayId}`
      );
    },
    onMarkAllDoneClick() {
      useTrack(ACCOUNT_EVENTS.MARK_AS_READ_NOTIFICATIONS);
      this.$store.dispatch('notifications/readAll');
    },
  },
};
</script>

<template>
  <div class="h-full overflow-y-auto bg-n-background">
    <div class="flex min-h-full flex-col">
      <NotificationTable
        :notifications="records"
        :is-loading="uiFlags.isFetching"
        :is-updating="uiFlags.isUpdating"
        :on-click-notification="openNotification"
        :on-click-related-conversation="openRelatedConversation"
        :on-mark-all-done-click="onMarkAllDoneClick"
        :on-refresh="refreshNotifications"
      />
      <TableFooter
        v-if="meta.count"
        class="mx-auto mb-8 w-full max-w-6xl border-t border-n-weak px-4 sm:px-6"
        :current-page="Number(meta.currentPage)"
        :total-count="meta.count"
        :page-size="15"
        @page-change="onPageChange"
      />
    </div>
  </div>
</template>
